import React, {useCallback, useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import SearchBar from "../components/SearchBar.js";
import DatePicker from "react-datepicker";
import {word} from "../word.js";
import Select from "react-select";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useParams} from "react-router-dom";
import Loader from "../components/BlueButton/Loader.js";
import makeAnimated from "react-select/animated";
import qs from "query-string";
import moment from "moment";
import {useNavigate} from "react-router";
import {REACT_APP_API_URL} from "../config.js";
import {accountantRequest, taskCompanyRequest, } from "../store/actions/task.js";
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import Api from "../Api.js"
import TaskItem from "../components/TaskItem.js";
import DeleteItem from "../components/TaskSingleComponents/DeleteItem.js";
const profession = localStorage.getItem("profession");
const date = new Date()
date.setMonth(date.getUTCMonth() - 3)
const end_date = new Date()
end_date.setDate(end_date.getUTCDate() + 1)
const userId = localStorage.getItem('id');
function Archive(props) {
    const navigate = useNavigate();
    const location = useLocation()
    const dispatch = useDispatch()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const [taskByStatus, setTaskByStatus] = useState([]);
    const [loading, setLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [startDate, setStartDate] = useState(query.start_date ? new Date(query.start_date) : new Date());
    const [endDate, setEndDate] = useState(query.end_date ? new Date(query.end_date) : new Date());
    const [selectedOrg, setSelectedOrg] = useState([]);
    const [selectedEmp, setSelectedEmp] = useState([]);
    const [deleteVisible, setDeleteVisible] = useState(null);
    const [filter, setFilter] = useState({
        status: 'end',
        start_date: '',
        end_date: '',
        company: '',
        accountant: '',
        page: 1,
        name: '',
        is_archive: true
    });

    const animatedComponents = makeAnimated();

    const updateFilter = async (newFilter) => {
        const updatedFilter = { ...filter, ...query, ...newFilter };
        setFilter(updatedFilter);

        const stringify = qs.stringify(updatedFilter, { addQueryPrefix: true });
        navigate(`?${stringify}`, { replace: true });

        await fetchData(updatedFilter,stringify);
    };
    const [limitData, setLimitData] = useState({
        orgs: [],
        stuff: [],
    });
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    useEffect(() => {
        (async () => {
            setLimitData({
                orgs: companies.map(s => ({value:s.id,label:s.name,url:REACT_APP_API_URL+'manager-company/'+s.id+'/'})),
                stuff: account.map(s => ({value:s.id,label:`${s.user.first_name} ${s.user.last_name}`,url:REACT_APP_API_URL+'accountant/'+s.id+'/'}))
            })
        })()
    }, [account,companies])
    useEffect(() => {
        (async () => {
            await dispatch(accountantRequest())
            await dispatch(taskCompanyRequest())
        })();
    }, []);
    const fetchData = async (filters,stringify) => {
        try{
            setLoading(true);
            const {data} = await Api.archivedTaskGet(filters,stringify)
            setCount(data.count)
            setTaskByStatus(data.results);
            setLoading(false)
        }catch (e) {

        }
    };

    useEffect(() => {
        (async () => {
            const initial = {
                ...(profession === 'accountant' ? { accountant: userId } : {}),
                is_archive: true
            };
            await updateFilter(initial);
        })()
    }, []);

    const handleCompanyChange = async (list) => {
        setSelectedOrg(list);
        const company = list.map(item => item.value).join(',');
        await updateFilter({ company });
    };

    const handleEmployeeChange = async(list) => {
        setSelectedEmp(list);
        const accountant = list.map(item => item.value).join(',');
        await updateFilter({ accountant });
    };

    const handlePageChange =async (pageNumber) => {
        const offset = pageNumber === 1 ? '' : (pageNumber - 1) * 10;
        await updateFilter({ offset,page:pageNumber });
    };


    const renderTasks = () => {
        if (loading) {
            return (
                <div className="loaderMargin">
                    <Loader type="Oval" color="#101C2A" height={30} width={30} />
                </div>
            );
        }

        return taskByStatus.map((item, index) => (
            <TaskItem
                key={index}
                link={`/main_employee/archive/${item.id}`}
                delete_archive={() => {
                    setDeleteVisible(item.id);
                }}
                item={item}
            />
        ));
    };
    const getSelectedList = (array, name) => {
        const selectedString = name === "company" ? query.company : query.accountant;
        const selectedIds = Array.isArray(selectedString) ? selectedString.map(id => parseInt(id, 10)) : [+selectedString];
        return array.filter(item => selectedIds.includes(item.value));
    };


    return (
        <Wrapper>
            <div className="archive">

                <div className={profession === 'manager' ? 'tasks-data tasks-data-manager' : 'tasks-data'}>
                <span className="tasks-data-item">
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={startDate}
                        onChange={(date) => {
                            setStartDate(date);
                            const formatted = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                            updateFilter({ start_date: formatted });
                        }}
                    />
                </span>
                    <div className="middle-line" />
                    <span className="tasks-data-item">
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={endDate}
                        onChange={(date) => {
                            setEndDate(date);
                            const formatted = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                            updateFilter({ end_date: formatted });
                        }}
                    />
                </span>
                    <div className="middle-line" />
                    <div className="tasks-data-hidden">
                        <Select
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    border: 'none',
                                    boxShadow: 'none', // Removes focus outline
                                }),
                            }}
                            defaultValue={limitData.orgs ? getSelectedList(limitData.orgs, 'company') : []}
                            isLoading={limitData.loader_orgs}
                            value={selectedOrg}
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            options={limitData.orgs}
                            onChange={handleCompanyChange}
                            placeholder={word.organizations}
                            isMulti
                        />
                    </div>
                    {profession === 'manager' && (
                        <>
                            <div className="middle-line" />
                            <div className="tasks-data-hidden">
                                <Select
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            border: 'none',
                                            boxShadow: 'none', // Removes focus outline
                                        }),
                                    }}
                                    isLoading={limitData.loader_stuff}
                                    defaultValue={limitData.stuff ? getSelectedList(limitData.stuff, 'stuff') : []}
                                    value={selectedEmp}
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    options={limitData.stuff}
                                    onChange={handleEmployeeChange}
                                    placeholder={word.employees}
                                    isMulti
                                />
                            </div>
                        </>
                    )}
                </div>
                <SearchBar value={filter.name} onChange={(val) => updateFilter({ name: val })} />
                <div className="data-user">
                    <span>{word.task_name}</span>
                    <span>{word.name_organization}</span>
                    <span>{word.performer_name}</span>
                    <span>{word.tasks_date}</span>
                    <span>{word.deadline}</span>
                </div>
                {renderTasks()}
                {count > 10 && (
                    <div className="d-flex justify-content-center">
                        <CustomPagination
                            currentPage={+query.offset? query.offset/10 + 1  : 1}
                            totalItems={count}
                            itemsPerPage={10}
                            totalPages={Math.ceil(count / 10) || 0}
                            onPageChange={(newPage) => handlePageChange(newPage)}
                        />
                    </div>
                )}
            </div>
            {deleteVisible ? <DeleteItem open={deleteVisible} setOpen={setDeleteVisible}/> : null}

        </Wrapper>
    );
}

export default Archive;